export default __webpack_public_path__ + "static/media/do-1@2x.1a27b46c.jpg";